import { useSelector } from 'react-redux';

import { useDeskId } from '@/hooks/useDeskId';
import { useIntegrations } from '@/hooks/useIntegrations';
import { getPermissions } from '@/redux/permissions/selectors';
import { selectIntegrationId } from '@/redux/session/selectors';
import { IntercomIntegration } from '@/shared/types/integration';
import { actions } from '@/shared/types/permissions';
import { RootState } from '@/shared/types/state';

import { ConnectCard } from './ConnectCard';
import { DeleteFieldset } from '../Components/DeleteFieldset';

interface Props {
  onAuthClick: () => void;
}

const IntercomOauth = ({ onAuthClick }: Props) => {
  const deskId = useDeskId();
  const integrationId = useSelector(selectIntegrationId);
  const { integration } = useIntegrations<IntercomIntegration>(deskId, integrationId);

  const canWrite = useSelector((state: RootState) =>
    getPermissions(state, 'integrations', actions.WRITE)
  );

  if (!integration) {
    return null;
  }

  return (
    <div className="flex w-xl flex-col gap-4">
      <ConnectCard onAuthClick={onAuthClick} disabled={!canWrite} />
      <div className="flex justify-start">
        <DeleteFieldset integration={integration} />
      </div>
    </div>
  );
};

export default IntercomOauth;
